import { Box, Grid, GridItem, Heading } from '@chakra-ui/react'

import { Asset, Call, Equipment } from '@/services/backend/config/entities'

import KanbanCardItem from './kanban.card.item'

type Extended = Call & {
  Asset: Asset & { Equipment?: Equipment }
}

interface Props {
  data: Extended[]
  title: string
  isExternal?: boolean
}

const GroupColumn = ({ isExternal, data, title }: Props) => {
  return (
    <Box bg="blackAlpha.50" p={4} minW={300}>
      <Box borderBottom="1px solid" borderBottomColor="gray.200" pb={2} mb={4}>
        <Heading fontSize="lg" fontWeight="light">
          {title}
        </Heading>
      </Box>

      <Box display="grid" overflowY="auto" maxH="50vh">
        {data.map((ea) => (
          <Box key={ea.id} mb={4} pr={2}>
            <KanbanCardItem
              data={ea}
              redirectTo={
                isExternal
                  ? `/externo/${ea.id}/detalhes`
                  : `/app/entity/chamados/${ea.id}/detalhes`
              }
            />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default function Component({
  data,
  isExternal,
}: {
  isExternal?: boolean
  data: Extended[]
}) {
  const sortedData = data.sort((a, b) => b.id - a.id)

  // prettier-ignore
  const callGroups = {
    open:         sortedData.filter(ea=>ea.status === 'OPEN'),
    techAssigned: sortedData.filter(ea=>ea.status === 'ASSIGNED'),
    techDoing:    sortedData.filter(ea=>ea.status === 'IN_PROGRESS'),
    techDone:     sortedData.filter(ea=>ea.status === 'DONE'),
    closed:       sortedData.filter(ea=>ea.status === 'CLOSED'),
    canceled:     sortedData.filter(ea=>ea.status === 'CANCELED'),
  }

  return (
    <Box display="grid" overflowX="auto" bg="gray.50" pb={4}>
      <Grid templateColumns="repeat(6, 1fr)" gap={4}>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Novos"
            data={callGroups.open}
          />
        </GridItem>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Atribuídos"
            data={callGroups.techAssigned}
          />
        </GridItem>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Em atendimento"
            data={callGroups.techDoing}
          />
        </GridItem>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Atendidos"
            data={callGroups.techDone}
          />
        </GridItem>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Encerrados"
            data={callGroups.closed}
          />
        </GridItem>
        <GridItem>
          <GroupColumn
            isExternal={isExternal}
            title="Cancelados"
            data={callGroups.canceled}
          />
        </GridItem>
      </Grid>
    </Box>
  )
}
